module.exports = __webpack_public_path__ + "img/3.3fa285c2.jpg";